import classes from "./CircleButton.module.scss";

const CircleButton = ({ children, onClick, className, disabled }) => {
  return (
    <button
      className={`${classes.circleButton} ${className}`}
      onClick={onClick}
      disabled={disabled}
    >
      {children}
    </button>
  );
}

export default CircleButton;